module.exports = __webpack_public_path__ + "img/noCoupon.a5dc157d.png";